import { gridTpl } from '../../../../../common/grid/grid.controller';

export const protectiveEquipmentTestReportsGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'ProtectiveEquipmentTestReportsGridController',
    ...gridTpl
};
